import {TypeAccountRoles} from '../types/user-account.types';

export const PROJECT_MANAGER_AND_ABOVE_ROLES: TypeAccountRoles[] = [
  TypeAccountRoles.PROJECT_MANAGER,
  TypeAccountRoles.DIRECTOR,
  TypeAccountRoles.FUNCTIONAL_ADMIN,
  TypeAccountRoles.ADMIN,
  TypeAccountRoles.OWNER,
];

export const CUSTOMER_AND_ABOVE_ROLES: TypeAccountRoles[] = [
  TypeAccountRoles.CUSTOMER,
  TypeAccountRoles.WORKER,
  ...PROJECT_MANAGER_AND_ABOVE_ROLES,
];
